export default "__VITE_ASSET__CeW3YW0M__"